import type { ResolvedComponent } from '@inertiajs/react';

type PageModule = { default: ResolvedComponent };

const pages = import.meta.glob<PageModule>([
    '../pages/**/*.tsx',
    '!../pages/**/_archive/**',
]);

/**
 * Resolves an Inertia page name to its component. Shared by the browser entry
 * (app.tsx) and the SSR entry (ssr.tsx) so both load the same page set.
 */
export function resolvePage(name: string): Promise<ResolvedComponent> {
    const load = pages[`../pages/${name}.tsx`];

    if (!load) {
        return Promise.reject(new Error(`Inertia page not found: ${name}`));
    }

    return load().then((module) => module.default);
}
